import { v4 as _uuidv } from "uuid";
const uuidv4 = _uuidv;
export default (class Metadata {
  constructor(options = {
    name: "",
    type: "text-input",
    options: [],
    value: ""
  }) {
    this.id = uuidv4();
    this.name = options.name || "Unknown";
    this.type = options.type || "text-input";
    this.options = options.options || [];
    this.value = options.value || "";
    /* Original field name in the source file (eg. "Translator's Name") */
    if (options.source) {
      this.source = options.source;
    }
  }
});